enum CompanyGroupingType {
  None = 0, // eslint-disable-line no-unused-vars
  SouthAfrican = 1, // eslint-disable-line no-unused-vars
  Foreign = 2, // eslint-disable-line no-unused-vars
}

export default CompanyGroupingType;
